export const api = {
  member: {
    list: "/item/v1/goods/list",
    memberv1: "/member/v1/members/",
    getPayCodeToken: "/member/v1/barcode/",
    backendUrlPayCodeTime: "/member/v1/barcode/systemTime",
    getMemberBanner: "/b2c-mall/v1/home/getCustomerBanner",
    getHomeDetail: "/b2c-mall/v1/home/getHomeDetail",
    getHomeSkuList: "/b2c-mall/v1/home/getHomeSkuListRecommend",
    getCustomerBanner: "/b2c-mall/v1/home/getCustomerBanner",
    // androidVersionCode: "/b2c-mall/v1/android/versionCode",
    androidVersionCode:"/b2c-mall/v1/android/versionCodeNew",
    newUser: 'b2c-mall/v1/customer/newUser'
  },
  area: {
    arealist: "/b2c-mall/v1/order/goodsSaleAreaLimit",
    // near:"/sdsdapi/v1/merchantMap/near",
    near: "/b2c-mall/v1/order/getDepotListByCountryId",
    getMemberReceiverList: "/customer/v1/api/members/getMemberReceiverList",
    upsertMemberReceiver: "/customer/v1/api/members/upsertMemberReceiver"
  },
  order: {
    orderList: "/b2c-mall/v1/order/getOrderList",
    orderDetail: "/b2c-mall/v1/order/getOrderDetail",
    orderDel: "/b2c-mall/v1/order/delete",
    logisticTrace: "/b2c-mall/v1/order/getOrderTraces",
    orderCandel: "/b2c-mall/v1/order/cancel",
    confirmReceipt: "/b2c-mall/v1/order/confirmReceipt",
    onlinePayment2: "order/v1/order/onlinePayment",
    onlinePayment: "/b2c-mall/v1/order/prepay",
    getSettlementPage: "/b2c-mall/v1/order/getCreateOrderInfo",
    getSettlementPage2: "/b2c-mall/v2/order/getCreateOrderInfo_v2", // 拼团
    // getSettlementPage:"/b2c-mall/v1/order/getOrderCreateInfo",
    getPaymentMethod: "/b2c-mall/v1/order/getPaymentMethodList",
    paying: "/b2c-mall/v1/order/paying",
  },
  detail: {
    detail: "/b2c-mall/v1/item/getItemDetail",
    isAreaSel: "/b2c-mall/v1/item/isSell",
    getSaleInventory: "/item/v1/goods/getSaleInventory",
    addCart: "/b2c-mall/v1/b2c/cart/addCart"
  },
  phoneLogin: {
    sendPhone: "/member/v1/sms/app/",
    goLogin: "member/v1/sms/app/login",
    toRefreshToken: "/member/v1/auth/refresh",
  },
  point: {
    pointList: "/member/v1/members/"
  },
  trans: {
    transCount: "/member/v2/members/",
    transCancel: "/member/v1/members/transactions/cancel/",
    backendUrlRequestment: "/member/v1/members/transactions/start",
  },
  orderConfirm: {
    getOrderPromotion: "/order/v1/order/getOrderPromotion",
    upsertMemberReceiver: "/customer/v1/api/members/upsertMemberReceiver",
    createOrder: "/b2c-mall/v1/order/createOrder",
    createOrder2: "/b2c-mall/v2/order/createOrder_v2",
    cacheUserDepot: "/b2c-mall/v1/order/cacheUserDepot",
    userPointCheck: "/b2c-mall/v1/order/userPointCheck",
    Newer: '/b2c-mall/v2/order/create'
  },
  txMap: "https://apis.map.qq.com/ws/geocoder/v1/",
  myPromotion: {
    backendUrlQRCode: "/member/v1/qrCodeUrl/get/",
    info: "/member/v1/members/promoter/info"
  },
  category: {
    list: "/b2c-mall/v1/category/getValidCategoryListToLevel",
    goodsList: "/b2c-mall/v1/category/getSkuListForCategory"
  },
  collage: {
    goodsList: "/b2c-mall/v1/pintuan/geActivityItemList",
    getItemPintuan: "/b2c-mall/v1/pintuan/getItemPintuan",
    joinCollage: "/b2c-mall/v1/pintuan/cantuan",
    startCollage: "/b2c-mall/v1/pintuan/kaituan",
    joinValidate: "/b2c-mall/v1/pintuan/cantuanValidate",
    collageDetail: "/b2c-mall/v1/pintuan/getPintuanDetail",
    pintuanValidate: "/b2c-mall/v1/pintuan/orderValidate"
  },
  shopcar: {
    list: "/b2c-mall/v1/b2c/cart/getCartInfo",
    select: "/b2c-mall/v1/b2c/cart/updateSelection",
    adddecrease: "/b2c-mall/v1/b2c/cart/updateNum",
    delete: "/b2c-mall/v1/b2c/cart/delCart",
    getNum: "/b2c-mall/v1/b2c/cart/getNum",
    shopclearCache: "/b2c-mall/v1/order/clearCache",
    newerSkuList: '/b2c-mall/v1/home/getHomeSkuListExclusive'
  },
  my: {
    getCustomerInfo: "/b2c-mall/v1/customer/info",
    getReceiveOrderList: "/b2c-mall/v1/order/getReceiveOrderList",
    getReceiveOrderNum: "/b2c-mall/v1/order/getReceiveOrderNum",
  },
  pintuan: {
    popular: "/b2c-mall/v1/home/getHomePintuan",
  },
  bury: {
    getToken: "/getToken",
    clientinfo: "/clientinfo",
    common: "/common"
  },
  coupon: {
    /**
     * @description 领劵中心
     */
    center: '/b2c-mall/v1/coupon/center',
    /**
     * @description 领取优惠券
     */
    get: '/b2c-mall/v1/coupon/get',
    /**
     * @description 我的优惠券
     */
    my: '/b2c-mall/v1/coupon/my',
    /**
     * @description 商品可用优惠券
     */
    list: '/b2c-mall/v1/coupon/product/list',
    /**
     * @description 结算页（订单详情）新 2021-06-17
     */
    orderInfo: '/b2c-mall/v1/order/info',
    /**
     * @description 提交订单(通用) 新 2021-06-17
     */
    orderSubmit: '/b2c-mall/v1/order/submit',
    /**
     * @description 使用优惠券
     */
    use: '/b2c-mall/v1/coupon/use',
    /**
     * @description 轮播图
     */
    banner:'/b2c-mall/v1/getBannersCouponCenter',
    /**
     * @description 获取优惠券数量
     */
    total:'/b2c-mall/v1/coupon/my/total'
  },
  /**
   * @description 搜索
   */
  search: {
    /**
     * 执行搜索
     */
    query:'/b2c-mall/v1/home/getHomeSkuListSearch',
    /**
     * @description 历史记录
     */
    history:'/b2c-mall/v1/customer/search/recordList',
    /**
     * @description 同步记录
     */
    record:'/b2c-mall/v1/customer/search/record'
  },
  /**
   * @description 签到相关
   */
  signIn:{
    /**
     * @description 立即签到
     */
    geSignIn:'/b2c-mall/v1/signin/getSignin',
    /**
     * @description 任务详情
     */
    task:'/b2c-mall/v1/signin/getSigninTaskCount',
    /**
     * @description 进度详情
     */
    detail:'/b2c-mall/v1/signin/getSigninDetails'
  },
  /**
   * @description 助力相关
   */
  help:{
    /**
     * @description 助力活动列表
     */
    list:'/b2c-mall/v1/home/getHomeDetailSupport',
    /**
     * @description 助力活动详情
     */
    detail:'/b2c-mall/v1/support/getSupportInfoDetails',
    /**
     * @description 我的助力列表
     */
    my:'/b2c-mall/v1/support/getMySupportList',
    /**
     * @description 发起助力分享
     */
    share:'/b2c-mall/v1/support/getShare',
    /**
     * @description 帮助好友助力
     */
    joinShare:'/b2c-mall/v1/support/getSupport',
    /**
     * @description 获取助力头像列表
     */
    joinList:'/b2c-mall/v1/support/getHeadPortrait'
  }
}